export enum Oauth2Properties{
  response_type ="response_type",
  redirect_uri = "redirect_uri",
  client_id = "client_id", 
  client_secret = "client_secret", 
  auth_url = "auth_url", 
  token_url = "token_url", 
  scope = "scope"
}

export enum IgnoreProperToRequestCode{
  auth_url ="auth_url", 
  token_url = "token_url", 
  client_secret ="client_secret"
}

export enum AuthenticationType {
  none = "none",
  basic = "Basic Authentication",
  oauth2 = "OAuth2 Authentication",
  digest = "Digest Authentication",
  custom = "custom",
}


export enum Environments{
  Development = "Development",
  Test = "Test",
  Production = "Production"
}

export enum states{
  successful = "successful",
  fail = "fail"
}

export enum commons {  
  state = "state",
  redirect_uri = "https://build.bizagi.com/redirectOauth2.html",
  patterUrl = "^(http|https)\://([a-zA-Z0-9\.\-]+(\:[a-zA-Z0-9\.&amp;%\$\-]+)*@)*((25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9])\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])|([a-zA-Z0-9\-]+\.)*[a-zA-Z0-9\-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(\:[0-9]+)*(/($|[a-zA-Z0-9\.\,\?\'\\\+&amp;%\$#\=~_\-]+))*$"
}

export enum AuthenticationFlow {
  codeGrant,
  clientCredentials
}
